import { Image, Typography } from '@/components/atoms'
import { ThemeColor } from '@/enums'
import { themeColor } from '@/utils'
import styled from 'styled-components'

const AdvisorTipWrapper = styled.div`
  display: flex;
  gap: 8px;
`

const TipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: ${themeColor(ThemeColor.b10)};
  padding: 8px;
  border-radius: 0px 8px 8px 8px;
  border: 1px solid ${themeColor(ThemeColor.glass200)};
`

const StyledImage = styled(Image)`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  object-fit: cover;
`

export const AdvisorTip = ({
  message,
  title,
}: {
  message: string
  title: string
}) => {
  return (
    <AdvisorTipWrapper>
      <StyledImage name="ava" type="webp" width="50px" height="50px" />
      <TipWrapper>
        <Typography bold variant="footnote">
          {title}
        </Typography>
        <Typography variant="footnote">{message}</Typography>
      </TipWrapper>
    </AdvisorTipWrapper>
  )
}
